module.exports = __webpack_public_path__ + "static/media/parejaPsico.c6b85a12.png";